import { FC } from 'react';

import { NothingIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';

import styles from './SearchResultEmpty.styles.m.css';

export const SearchResultEmpty: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <NothingIcon className={styles.icon} />
      <div className={styles.text}>{t('search_no_results')}</div>
    </div>
  );
};
